<script>
    export default {
        name: "widget-list-row-header",
        computed: {
            translations() {
                return {
                    added: Lang.langGet("Added at"),
                    name: Lang.langGet("Name"),
                    version: Lang.langGet("Version"),
                    author: Lang.langGet("Author"),
                    description: Lang.langGet("Description"),
                }
            }
        }
    }
</script>

<template>
    <div class="widget-element-row-header">
        <div class="widget-element-row-cell"/>
        <div class="widget-element-row-cell"/>
        <div class="widget-element-row-cell">{{ translations.name }}</div>
        <div class="widget-element-row-cell">{{ translations.version }}</div>
        <div class="widget-element-row-cell">{{ translations.author }}</div>
        <div class="widget-element-row-cell">{{ translations.description }}</div>
        <div class="widget-element-row-cell">{{ translations.added }}</div>
        <div class="widget-element-row-cell"/>
    </div>
</template>
